"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeForApplets = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var login_1 = require("../../model/login");
var service_1 = require("../../../library/base/service");
var GetPhoneDynamicCodeForApplets = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetPhoneDynamicCodeForApplets, _super);
    function GetPhoneDynamicCodeForApplets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取短信验证码';
        _this.code = '300408';
        _this.desc = '获取短信验证码';
        _this.requestParams = new login_1.GetPhoneDynamicCodeForAppletsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetPhoneDynamicCodeForApplets;
}(service_1.BaseService));
exports.GetPhoneDynamicCodeForApplets = GetPhoneDynamicCodeForApplets;
//# sourceMappingURL=getPhoneDynamicCodeForApplets.js.map